<template>
  <div class="md:pb-20 lg:pb-20 relative z-index1">
    <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto px-4"
    />
    <!-- <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto px-4"
    /> -->
    <!-- <div
      class="absolute insights-bg z-index--1 md:block lg:block hidden md-hidden"
    >
      <img
        src="../../../../assets/images/line/insig-line.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div> -->
    <!-- <div class="absolute insights-bg-mob md:hidden lg:hidden block">
      <img
        src="../../../../assets/images/line/inst-news-bg-mob.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div> -->
    <div class="lg:pt-0 md:pt-0">
      <div
        class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-4 mx-auto md:pt-0 lg:pt-0"
      >
        <div class="flex justify-between items-center">
          <p
            class="title fsize36-16px-isg lg:font-normal md:font-normal font-bold z-10"
          >
            Latest News
          </p>
        </div>
        <div class="md:pt-10 lg:pt-10 pt-0">
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-x-8 md:gap-y-8 lg:gap-y-8"
          >
            <BlogItem
              v-for="item in categorywisepages.data"
              :key="item._id"
              :item="item"
              :category="item.pageCategory.name"
              :data="categorywisepages"
            />
          </div>
          <div class="flex mt-4 flex-wrap">
            <b-pagination
              @change="handlePageChange"
              v-model="currentPage"
              :total-rows="rows"
              size="lg"
            ></b-pagination>
            <!-- <b-pagination
              @change="
                (value) => {
                  currentPage = value;
                }
              "
              pills
              :total-rows="total_row"
              :per-page="perPage"
              size="lg"
              class="ml-auto flex flex-wrap"
            ></b-pagination> -->

            <!-- <link-prevue
              v-for="item in filteredData"
              :key="item._id"
              :apiUrl="$apiUrl + 'cms/page/'"
              :url="item.link"
            >
              <template slot-scope="props">
                <div
                  class="md:mt-0 lg:mt-0 mt-6"
                  @click="handleOpenNews(props.url)"
                >
                  <img
                    :src="props.img"
                    alt="News image"
                    class="rounded-lg h-52 w-full object-cover cursor-pointer"
                  />
                  <p
                    class="
                      md:mt-5
                      lg:mt-5
                      mt-2
                      text-black
                      footertitle
                      font-bold
                      cursor-pointer
                      fsize24-14px
                      ellipsis-2
                    "
                  >
                    {{ props.title }}
                  </p>
                  <div class="md:mt-5 lg:mt-5 mt-2 flex"></div>
                </div>
              </template>
            </link-prevue> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlogItem from "./BlogItem.vue";
import pageMixin from "@/views/social/admin/pages/blog/mixins/pageMixin";
import { mapState } from "vuex";

export default {
  mixins: [pageMixin],
  components: {
    BlogItem,
  },
  data() {
    return {
      filteredData: [],
      categoryId: null,
      currentPage: 1,
      perPage: 16,
      // rows: Number,
      rows: 1,
      tagid: [],
    };
    // return {
    // urls: [
    //   "https://swarajyamag.com/infrastructure/why-family-caregivers-need-a-hand-to-hold",
    //   "https://feminisminindia.com/2019/04/25/caregiving-beyond-gender-boundaries/",
    //   "https://mumbaimirror.indiatimes.com/others/health-lifestyle/taking-care-of-the-caregiver/articleshow/69527485.cms?fbclid=IwAR3U89uZg89kz7PSGJIuG_QR921jZu80EiYl3BeT-37hKgqSMDOEnIT6ddk",
    //   "https://www.thenewsminute.com/article/burden-caregiving-indian-caregivers-battles-they-fight-every-day-103192",
    //   "https://www.deccanherald.com/amp/opinion/in-perspective/sunset-years-with-sons-settled-abroad-797233.html",
    //   "https://economictimes.indiatimes.com/magazines/panache/dealing-with-dementia-a-disease-that-affects-memory-thinking-and-judgement/articleshow/73339613.cms?from=mdr",
    //   "https://www.mid-day.com/sunday-mid-day/article/this-is-also-a-mental-health-pandemic--say-mumbai-psychiatrists--23138291",
    //   "https://timesofindia.indiatimes.com/india/its-complicated-grief-in-the-age-of-covid-19/articleshow/82700540.cms?from=mdr",
    //   "https://www.thehindu.com/news/national/coronavirus-grief-groceries-all-shared-in-this-fight/article34522986.ece",
    //   "https://www.thehindu.com/society/sukh-dukh-a-helpline-in-eight-languages-for-grief-counselling/article34527528.ece",
    //   "https://www.asianage.com/age-on-sunday/121019/death-over-dinner.html",
    //   "https://www.thehindu.com/sci-tech/health/how-to-provide-care-for-the-caregiver/article25763695.ece",
    // ],
    // };
  },
  computed: {
    ...mapState("cms", {
      pageCategories: "pageCategories",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),
    // total_row() {
    //   return this.pages.length;
    // },
    // displayedPages() {
    //   return this.pages.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
    handleOpenNews(url) {
      window.open(url, "_blank");
    },
    async handlePageChange(value) {
      this.currentPage = value;
      let payload = {
        offset:
          this.currentPage > 1 ? (this.currentPage - 1) * 10 : this.currentPage,
        id: this.categoryId,
        // tagid: this.tagid,
      };
      this.filteredData = await this.$store.dispatch(
        "cms/getpagebycategory",
        payload
      );
    },
    async init() {
      let data = await this.$store.dispatch("cms/getPageCategories");
      this.rows = data.data.totalPages;

      this.pageCategories.forEach((element) => {
        if (element.route.includes("news")) this.categoryId = element._id;
      });

      let filteredAPIData = await this.$store.dispatch(
        "cms/getpagebycategory",
        {
          id: this.categoryId,
        }
      );
      this.filteredData = filteredAPIData.data;
      this.rows = Number(this.filteredData.totalPages);
    },
  },
  mounted() {
    this.init();
    // console.log("student");
  },
};
</script>
